import type { SearchTermProps } from './TrendingSearchList.controller';

export const TOP_200_MOST_SEARCH_TERMS: SearchTermProps[] = [
  { searchText: 'kitchenaid' },
  { searchText: 'le creuset' },
  { searchText: 'caraway' },
  { searchText: 'dyson' },
  { searchText: 'vitamix' },
  { searchText: 'yeti' },
  { searchText: 'blender' },
  { searchText: 'all clad' },
  { searchText: 'brooklinen' },
  { searchText: 'parachute' },
  { searchText: 'ninja' },
  { searchText: 'rice cooker' },
  { searchText: 'smeg' },
  { searchText: 'beis' },
  { searchText: 'hexclad' },
  { searchText: 'breville' },
  { searchText: 'blackstone' },
  { searchText: 'staub' },
  { searchText: 'newly named' },
  { searchText: 'quince' },
  { searchText: 'made in' },
  { searchText: 'greenpan' },
  { searchText: 'cozy earth' },
  { searchText: 'ooni' },
  { searchText: 'fellow' },
  { searchText: 'cuisinart' },
  { searchText: 'shark' },
  { searchText: 'irobot' },
  { searchText: 'pressed floral' },
  { searchText: 'oxo' },
  { searchText: 'joseph joseph' },
  { searchText: 'joyjolt' },
  { searchText: 'coleman' },
  { searchText: 'wusthof' },
  { searchText: 'umbra' },
  { searchText: 'lodge cast iron' },
  { searchText: 'casafina' },
  { searchText: 'lenox' },
  { searchText: 'madison park' },
  { searchText: 'libbey' },
  { searchText: 'fable' },
  { searchText: 'villeroy & boch' },
  { searchText: 'stone + lain' },
  { searchText: 'cutting board' },
  { searchText: 'flatware' },
  { searchText: 'towels' },
  { searchText: 'knife set' },
  { searchText: 'wine glasses' },
  { searchText: 'air fryer' },
  { searchText: 'dutch oven' },
  { searchText: 'vacuum' },
  { searchText: 'cooler' },
  { searchText: 'food processor' },
  { searchText: 'measuring cups' },
  { searchText: 'mixing bowls' },
  { searchText: 'waffle maker' },
  { searchText: 'samsonite' },
  { searchText: 'cookware set' },
  { searchText: 'luggage' },
  { searchText: 'espresso machine' },
  { searchText: 'air purifier' },
  { searchText: 'coffee maker' },
  { searchText: 'cake stand' },
  { searchText: 'towel warmer' },
  { searchText: 'food storage' },
  { searchText: 'our place' },
  { searchText: 'record player' },
  { searchText: 'fiestaware' },
  { searchText: 'schmidt brothers' },
  { searchText: 'pickleball' },
  { searchText: 'irobot' },
  { searchText: 'ninja creami' },
  { searchText: 'juicers' },
  { searchText: 'silverware' },
  { searchText: 'toaster' },
  { searchText: 'kettle' },
  { searchText: 'wok' },
  { searchText: 'immersion blender' },
  { searchText: 'sheets' },
  { searchText: 'stand mixer' },
  { searchText: 'pizza oven' },
  { searchText: 'bakeware set' },
  { searchText: 'serving bowl' },
  { searchText: 'serving platter' },
  { searchText: 'bath mat' },
  { searchText: 'roomba' },
  { searchText: 'cast iron' },
  { searchText: 'trash can' },
  { searchText: 'ice cream maker' },
  { searchText: 'measuring spoons' },
  { searchText: 'steamer' },
  { searchText: 'slow cooker' },
  { searchText: 'salad spinner' },
  { searchText: 'stainless steel cookware' },
  { searchText: 'utensil set' },
  { searchText: 'steak knives' },
  { searchText: 'delta' },
  { searchText: 'airbnb' },
  { searchText: 'vase' },
];
